"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagTeamsProperty = exports.tagTeamsPropertyDefinition = void 0;
exports.tagTeamsPropertyDefinition = {
    view: {
        label: 'Teams',
        style: '',
        hint: 'Related to a team? Tag it and the asset shows on the team collection page.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['team'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'tag-teams',
};
const isTagTeamsProperty = (prop) => {
    return prop.name === exports.tagTeamsPropertyDefinition.name;
};
exports.isTagTeamsProperty = isTagTeamsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLXRlYW1zLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdGFnLXRlYW1zLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLE9BQU87UUFDZCxLQUFLLEVBQUUsRUFBRTtRQUNULElBQUksRUFBRSw0RUFBNEU7S0FDbkY7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLE1BQU0sQ0FBQztTQUNuQjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxXQUFXO0NBQ2MsQ0FBQTtBQUkxQixNQUFNLGtCQUFrQixHQUFHLENBQUMsSUFBa0IsRUFBNEIsRUFBRTtJQUNqRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssa0NBQTBCLENBQUMsSUFBSSxDQUFBO0FBQ3RELENBQUMsQ0FBQTtBQUZZLFFBQUEsa0JBQWtCLHNCQUU5QiJ9